
// Mock data based on your schema
const servicesData = [
  {
    name: "Professional Installation",
    description: "Expert installation of your equipment with full configuration support",
    price: 199.99,
    serviceType: "installation"
  },
  {
    name: "Custom System Setup",
    description: "Tailored system configuration to meet your specific needs",
    price: 299.99,
    serviceType: "customization"
  },
  {
    name: "24/7 Technical Support",
    description: "Round-the-clock technical assistance for your systems",
    price: 149.99,
    serviceType: "support"
  },
  {
    name: "Preventive Maintenance",
    description: "Regular system checkups and preventive maintenance",
    price: 179.99,
    serviceType: "maintenance"
  },
  {
    name: "Custom Solution Design",
    description: "Bespoke system design for unique requirements",
    price: 399.99,
    serviceType: "customization"
  },
];

const ServicesPageTemp = () => {
  // Group services by serviceType
  const groupedServices = servicesData.reduce((acc, service) => {
    const { serviceType } = service;
    if (!acc[serviceType]) {
      acc[serviceType] = [];
    }
    acc[serviceType].push(service);
    return acc;
  }, {});

  // Capitalize first letter
  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl font-extrabold text-[#001f3f] mb-8 text-center">
          Our Services
        </h2>

        {Object.entries(groupedServices).map(([type, services]) => (
          <div key={type} className="mb-12">
            <h3 className="text-2xl font-semibold text-[#1e3a8a] mb-6 border-b-2 border-[#1c3d6e] pb-2">
              {capitalize(type)}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {services.map((service) => (
                <div 
                  key={service.name}
                  className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
                >
                  <div className="p-6">
                    <h4 className="text-xl font-bold text-[#334E7D] mb-2">
                      {service.name}
                    </h4>
                    <p className="text-gray-600 mb-4">
                      {service.description}
                    </p>
                    <div className="flex justify-between items-center">
                      <span className="text-2xl font-bold text-[#1c3d6e]">
                        ${service.price.toFixed(2)}
                      </span>
                      <button className="bg-[#001f3f] text-white px-4 py-2 rounded-md hover:bg-[#1e3a8a] transition-colors duration-300">
                        Learn More
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServicesPageTemp;